export default "__VITE_ASSET__La$nIbIj__"